import React, {useContext, useEffect, useRef, useState} from 'react';
import ReactPlayer from 'react-player';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import arrowDark from '../../images/arrow-dark.svg';
import playButton from '../../images/playButton.svg';
import rewind from '../../images/rewind.svg';
import pauseButton from '../../images/pause.svg';

import {Settings} from '../../store';
import transcript from './Transcript';

const AudioPlayer = (props) => {
    const {url, audioPlayStatus, setFinalModal} = props;
    const dispatch = useContext(Settings.Dispatch);
    const settingsState = useContext(Settings.State);
    const {audioModal, transcriptModal, galleryModal, currentStopNumber, totalStops} = settingsState;
    const playerRef = useRef(null);
    const [playing, setPlaying] = useState(audioPlayStatus);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [isDragging, setIsDragging] = useState(false);


    const hideAudioModal = () => {
        dispatch({
            type: 'setStates',
            payload: {
                audioModal: false,
            },
        });
    };
    const showAudioModal = () => {
        dispatch({
            type: 'setStates',
            payload: {
                audioModal: true,
                transcriptModal: false,
                galleryModal: false,
            },
        });
    };

    // Format time to mm:ss
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
    };
    // Play/Pause toggle
    const handlePlayPause = () => {
        setPlaying(!playing);
    };

    // Stop the audio
    const handleStop = () => {
        setPlaying(false);
        playerRef.current.seekTo(0);
    };

    const handleRewind = () => {
        const currentTime = playerRef.current.getCurrentTime();
        playerRef.current.seekTo(currentTime - 10 > 0 ? currentTime - 10 : 0);
    };

    useEffect(() => {
        setPlaying(audioPlayStatus);
    }, [audioPlayStatus]);

    const handleForward = () => {
        const currentTime = playerRef.current.getCurrentTime();
        const duration = playerRef.current.getDuration();
        playerRef.current.seekTo(currentTime + 10 < duration ? currentTime + 10 : duration);
    };

    const handleProgress = (state) => {
        if (!isDragging) {
            setCurrentTime(state.playedSeconds);
        }
    };

    const handleDuration = (duration) => setDuration(duration);

    const handleDotDragStart = () => setIsDragging(true);

    const handleDotDragEnd = () => setIsDragging(false);

    const handleDotDrag = (e) => {
        if (isDragging) {
            const rect = e.currentTarget.getBoundingClientRect();
            const clickX = e.type === "touchmove" ? e.touches[0].clientX - rect.left : e.clientX - rect.left;
            const newTime = Math.max(0, Math.min((clickX / rect.width) * duration, duration));
            setCurrentTime(newTime);
            playerRef.current.seekTo(newTime / duration);
        }
    };

    const handleSeekChange = (e) => {
        setCurrentTime(parseFloat(e.target.value));
        playerRef.current.seekTo(parseFloat(e.target.value) / duration);
    };

    const handleProgressClick = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const newTime = (clickX / rect.width) * duration;
        playerRef.current.seekTo(newTime);
        setCurrentTime(newTime);
    };

    const progressPercentage = (currentTime / duration) * 100 || 0;

    const handleEnded = () => {
        playerRef.current.seekTo(0);
        setPlaying(false);
        if (currentStopNumber === totalStops.length && setFinalModal) {
            setFinalModal(true);
        }
    };

    return (<>
                {!audioModal || (transcriptModal || galleryModal) ?
                        <Button className="audio-button" onClick={showAudioModal}><span>Audio</span><img src={arrowDark}
                                                                                                         alt=""/></Button> : ''}
                <Modal size="sm"
                       fullscreen={false}
                       id={'audio-modal'}
                       scrollable={false}
                       dialogClassName={'d-flex align-items-start m-0'}
                       aria-labelledby="contained-modal-title-vcenter"
                       backdrop={false}
                       className={'p-0 m-0 audio-modal'}
                       show={audioModal} onHide={hideAudioModal}
                >
                    <Modal.Header className="p-0" closeButton>
                    </Modal.Header>
                    <Modal.Body className={'p-0'}>
                        <div className="mt-3">
                            <ReactPlayer
                                    bottom={'sd'}
                                    ref={playerRef}
                                    url={url}
                                    playing={playing}
                                    controls={false}
                                    width="0px"
                                    height="0px"
                                    onProgress={handleProgress}
                                    onDuration={handleDuration}
                                    onEnded={handleEnded}

                            />
                            <div
                                    className="progress-bar"
                                    onClick={handleProgressClick}
                                    onMouseDown={handleDotDragStart}
                                    onTouchStart={handleDotDragStart}
                                    onMouseMove={handleDotDrag}
                                    onTouchMove={handleDotDrag}
                                    onMouseUp={handleDotDragEnd}
                                    onTouchEnd={handleDotDragEnd}
                            >
                                <div
                                        className="progress-filled"
                                        style={{width: `${progressPercentage}%`}}
                                ><span className="dot"></span></div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mt-1"
                                 style={{fontSize: 12}}>
                                <span>{formatTime(currentTime)}</span>
                                <span>{formatTime(duration)}</span>
                            </div>
                            <div className="controls text-center align-items-center d-flex justify-content-center">
                                <span className="d-block"  role="button" onClick={handleRewind}><img src={rewind} alt="rewind"/></span>
                                <span className="d-block" role="button" style={{margin: '0 16px'}}
                                      onClick={handlePlayPause}>{playing ?
                                        <img src={pauseButton}/> :
                                        <img src={playButton}/>}
                    </span>
                                <span className="d-block" role="button" onClick={handleForward}>
                    <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.7476 4.42778C16.2708 2.08651 15.1455 0.433714 15.1455 0H13.9702H12.7957V8.7399V17.479H13.9702H15.1455C15.1455 17.0453 16.2708 15.3925 19.7476 13.0512C22.664 11.0882 25.3679 9.91444 26.297 9.91444V8.7399V7.56458C25.3679 7.56458 22.664 6.39082 19.7476 4.42778Z" fill="#001233"/>
                        <path d="M6.9519 4.42778C3.47517 2.08651 2.34986 0.433714 2.34986 0H1.17455H0V8.7399V17.479H1.17455H2.34986C2.34986 17.0453 3.47517 15.3925 6.9519 13.0512C9.86835 11.0882 12.5722 9.91444 13.5014 9.91444V8.7399V7.56458C12.5722 7.56458 9.86835 6.39082 6.9519 4.42778Z" fill="#001233"/>
                    </svg>
                </span>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
    )
            ;
};

export default AudioPlayer;
